import React, { InputHTMLAttributes } from 'react';
import { cx } from './cx';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  children?: React.ReactNode;
}

const Checkbox: React.FC<CheckboxProps> = ({ children, className, ...props }) => {
  return (
    <label className="osrs-check-row">
      <input type="checkbox" className={cx('osrs-check', className)} {...props} />
      {children}
    </label>
  );
};

export default Checkbox;
